import * as vp from 'vopay';
import { FunctionComponent } from 'react';

const { Box, SubTitle, Icon } = vp;
type LoadingProps = {
  LoadingMessage: string;
};
type FC = FunctionComponent<LoadingProps>;

const Error: FC = (props: LoadingProps) => {
  const { LoadingMessage } = props;
  return (
    <>
      <Box flx="col" width="100%" height="auto">
        <SubTitle center subTitle={LoadingMessage} />
      </Box>
      <Box jc="center">
        <Icon icon="loader" size="xl-jumbo" />
      </Box>
    </>
  );
};

export default Error;
